import { ComponentProps, useMemo } from 'react'
import styles from './Layout.module.scss'
import { TKind } from '../../utils'


interface ILayout extends ComponentProps<"div"> {
  kind?: TKind
}

const Layout = (props: ILayout) => {
  const { children, kind='red', className, ...args } = props
  
  const combinedClassname = useMemo(() => {
    return `${styles.root} ${kind === 'white' ? styles.white : styles.red} ${className}`
  }, [className, kind])

  return (
    <div className={combinedClassname} {...args}>
      {children}
    </div>
  )
}

export default Layout